import { gql } from '@apollo/client';

export const activateLoyaltyOfferMutation = gql`
  mutation activateLoyaltyOffer($tokenId: String!) @authRequired {
    activateLoyaltyOffer(tokenId: $tokenId)
  }
`;
